var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.vehicleRef,staticStyle:{"height":"46.5px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }